import React, { useState } from 'react';
import { EngineeringHomePage, PushPierCalculator } from './EngineeringGear';

const EngineeringGearPage = ({ currentUser, onBackToGears }) => {
  const [currentPage, setCurrentPage] = useState('home');

  switch (currentPage) {
    case 'home':
      return <EngineeringHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
    case 'push-pier-calculator':
      return <PushPierCalculator onBack={() => setCurrentPage('home')} currentUser={currentUser} />;
    default:
      return <EngineeringHomePage onNavigate={setCurrentPage} onBackToGears={onBackToGears} currentUser={currentUser} />;
  }
};

export default EngineeringGearPage;
